'use client'

import { useSignals } from '@preact/signals-react/runtime'
import PriceInfo from '@susu/headless-commerce/components/PriceInfo/PriceInfo'
import { useCountry } from '@susu/headless-commerce/contexts/country/client'
import { useCurrencies } from '@susu/headless-commerce/contexts/currencies/client'
import styles from '@susu/headless-commerce/features/configurator/components/CampaignInfo/CampaignInfo.module.scss'
import { configuratorSignal } from '@susu/headless-commerce/features/configurator/signals/configurator'
import { useI18N } from '@susu/i18n/client'
import { isUndefined } from '@susu/undefined'
import classNames from 'classnames'

export const ClientCampaignInfo = () => {
  useSignals()

  const country = useCountry()
  const currencies = useCurrencies()
  const configurator = configuratorSignal.value
  const { t } = useI18N()

  const campaign = configurator.selectedCampaign.value
  if (isUndefined(campaign)) {
    return null
  }

  return (
    <div
      className={classNames(
        styles['campaign-info'],
        'body-small-medium-sm body-medium-lg',
      )}
      data-testid="configurator_price"
    >
      {t('configurator.total')}{' '}
      <PriceInfo
        price={campaign.discounted.value}
        country={country}
        currencies={currencies}
      />
    </div>
  )
}
